import { render, staticRenderFns } from "./IconReminderAction.vue?vue&type=template&id=580ea63d&"
import script from "./IconReminderAction.vue?vue&type=script&lang=ts&"
export * from "./IconReminderAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports